import { X } from "lucide-react";

import { FilePreview } from "@/components/FilePreview";
import { stripBundlePrefix } from "@/utils/bundle-name";

import { DocSorterFileSchema } from "@api/generated/types.gen";

import { Button } from "@components/ui/button";

import { FilePreviewDialog } from "./FilePreviewDialog";

type DocumentPreviewProps = {
  fileName?: string;
  fileUrl: string | null;
  fileType: string | null;
  onClose: () => void;
  onRetry?: () => void;
  isLoading?: boolean;
  fileLoadError?: boolean;
  file?: DocSorterFileSchema;
  caseNumber?: string;
};

export const DocumentPreview = ({
  fileName,
  fileUrl,
  fileType,
  onClose,
  onRetry,
  isLoading = false,
  fileLoadError = false,
  file,
  caseNumber,
}: DocumentPreviewProps) => {
  return (
    <div className="h-full overflow-hidden">
      <div className="flex h-full flex-col overflow-hidden border-l border-border p-4">
        <div className="flex-shrink-0">
          <div className="relative mb-2 w-full">
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="absolute right-[-10px] top-[-10px] h-8 w-8"
            >
              <X className="h-4 w-4" />
            </Button>

            <h2 className="mb-1 text-lg font-semibold">Document Preview</h2>
            <div className="flex items-center justify-between gap-2">
              <h3
                className="text-muted-foreground min-w-0 flex-1 truncate text-sm"
                title={
                  fileName ? stripBundlePrefix(fileName) : "No document selected"
                }
              >
                {fileName ? stripBundlePrefix(fileName) : "No document selected"}
              </h3>

              <div className="flex items-center gap-2">
                <FilePreviewDialog
                  fileName={fileName}
                  fileUrl={fileUrl}
                  fileType={fileType}
                  file={file}
                  showSummaryOption={true}
                  caseNumber={caseNumber}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="min-h-0 flex-1 overflow-hidden">
          <FilePreview
            key={fileUrl || "no-file"}
            fileUrl={fileUrl}
            fileType={fileType as "pdf" | "image" | "other" | null}
            filename={fileName}
            isLoading={isLoading}
            fileLoadError={fileLoadError}
            onRetry={onRetry}
            showZoomControls={false}
          />
        </div>
      </div>
    </div>
  );
};
